import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { QuotePage, isQuoteRoute } from './QuotePage';
import { GiftCardOrderPage, isGiftCardOrderRoute } from './GiftCardOrderPage';
import './styles.css';

const el = document.getElementById('root');
if (!el) throw new Error('manage: #root missing');

// /offerte?q=<token>: the team outing quote accept page (booking-team);
// /cadeaubon?t=<token>: the gift cards of an online order (gift card shop);
// everything else is the booking self-service page.
createRoot(el).render(
  <StrictMode>
    {isGiftCardOrderRoute() ? <GiftCardOrderPage /> : isQuoteRoute() ? <QuotePage /> : <App />}
  </StrictMode>,
);
